import React from "react";
import Dropdown from "../form/Dropdown";

const AddressItem = ({
  data,
  onSetDefault,

  setAddModalOpen = () => {},
  setDeleteModal = () => {},
}) => {
  const typeHexColorMap = {
    Home: "#ef427c",
    Office: "#06D6A0",
    Relatives: "#fb923c",
    Others: "#4f46e5",
  };

  const dropdownData = [
    ...(data?.isDefault
      ? []
      : [
          {
            name: "Set Default",
            icon: "fa-regular fa-lightbulb-slash",
            click: () => onSetDefault(data._id),
          },
        ]),
    {
      name: "Edit",
      icon: "fa-regular fa-pen-to-square",
      // click: () => setAddModalOpen(true),
      click: () => setAddModalOpen(data),
    },
    ...(data?.isDefault
      ? []
      : [
          {
            name: "Delete",
            icon: "fa-regular fa-trash-can",
            click: () => setDeleteModal({ isOpen: true, data }),
          },
        ]),
  ];

  return (
    <>
      <div
        className="relative overflow-hidden py-4 px-4 border border-md-pink-light-1 bg-white rounded-lg hover:shadow-md hover:shadow-md-pink/20 transition-all duration-300 hover:bg-md-pink-light-2 z-0"
        style={{ "--typeColor": typeHexColorMap[data?.addressType] }}
      >
        <div
          className="absolute bottom-0 left-0 h-20 w-full -z-10 translate-y-1/2 rounded-[50%] blur-xl opacity-10"
          style={{ backgroundColor: "var(--typeColor)" }}
        />
        <div className="relative z-10 flex items-start flex-col gap-6">
          <div className="flex justify-between w-full">
            <div
              className="relative z-0 flex-shrink-0 w-16 aspect-square flex items-center justify-center text-3xl rounded-lg"
              style={{
                boxShadow: "0 4px 10px -6px var(--typeColor)",
                color: "var(--typeColor)",
              }}
            >
              <div
                className="absolute inset-0 rounded-lg opacity-10 -z-[2]"
                style={{ backgroundColor: "var(--typeColor)" }}
              />
              <div
                className="absolute inset-0 rounded-lg border opacity-10 -z-[1]"
                style={{ borderColor: "var(--typeColor)" }}
              />
              <i className="fa-light fa-fw fa-house-building"></i>
            </div>
            <div className="ml-auto flex flex-col gap-2 justify-between items-end">
              <div className="flex items-center gap-1">
                <div
                  className="relative flex items-center justify-center text-xs font-semibold pb-0.5 h-6 px-2 rounded"
                  style={{ color: "var(--typeColor)" }}
                >
                  <div
                    className="absolute inset-0 rounded opacity-10"
                    style={{ backgroundColor: "var(--typeColor)" }}
                  />
                  <div
                    className="absolute inset-0 rounded border opacity-10"
                    style={{ borderColor: "var(--typeColor)" }}
                  />
                  {data?.addressType}
                </div>
                <div>
                  <Dropdown
                    buttonIcon={
                      "fa-solid fa-ellipsis-vertical text-xs text-md-dark"
                    }
                    buttonIconPosition={"left"}
                    buttonArrowIcon={""}
                    xPlacement="bottomRight"
                    buttonClasses="flex items-center justify-center !h-6 !w-6 !p-0"
                    data={dropdownData}
                    dropdownContainer={"!w-32"}
                  />
                </div>
              </div>
              {data?.isDefault && (
                <div
                  className="relative ml-auto flex items-center justify-center text-xs font-semibold pb-0.5 h-6 px-2 rounded"
                  style={{ color: "var(--typeColor)" }}
                >
                  <div
                    className="absolute inset-0 rounded opacity-10"
                    style={{ backgroundColor: "var(--typeColor)" }}
                  />
                  <div
                    className="absolute inset-0 rounded border opacity-10"
                    style={{ borderColor: "var(--typeColor)" }}
                  />
                  Default Address
                </div>
              )}
            </div>
          </div>
          <div className="space-y-1 flex-grow flex-shrink">
            <div className="flex items-start justify-between gap-4">
              <div className="text-sm 2xl:text-base text-md-dark font-semibold">
                {data?.name}
              </div>
            </div>
            <div className="text-xs 2xl:text-sm text-slate-500 tracking-wide flex items-start gap-3">
              <i
                className="fa-regular flex-shrink-0 fa-fw fa-buildings pt-1"
                style={{ color: "var(--typeColor)" }}
              ></i>
              <span>{data?.addressLine1 + ", " + data?.addressLine2}</span>
            </div>
            <div className="text-xs 2xl:text-sm text-slate-500 tracking-wide flex items-start gap-3">
              <i
                className="fa-regular flex-shrink-0 fa-fw fa-phone pt-1"
                style={{ color: "var(--typeColor)" }}
              ></i>
              <span>{data?.phone}</span>
            </div>
            <div className="text-xs 2xl:text-sm text-slate-500 tracking-wide flex items-start gap-3">
              <i
                className="fa-regular flex-shrink-0 fa-fw fa-envelope pt-1"
                style={{ color: "var(--typeColor)" }}
              ></i>
              <span>{data?.email}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddressItem;
